import React, { FC, useState } from "react";
import "./BulkArticlePost.css";
import ExpandableMenu from "../ExpandableMenu/ExpandableMenu";
import ManagerRightDiv from "../ManagerRightDiv/ManagerRightDiv";

interface BulkArticlePostProps {}

const BulkArticlePost: FC<BulkArticlePostProps> = () => {
  const [expandedMenu, setExpandedMenu] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<string>("bparticle");
  return (
    <>
      <div className="container">
        <div className="row">
          <ExpandableMenu activeTabs={activeTab} expandedMenus={expandedMenu} />
          <ManagerRightDiv aid={5} aposturl="/apis/nuhman/articles-bulk" />
        </div>
      </div>
    </>
  );
};

export default BulkArticlePost;
